  
<!--降雨实况-->
<template>
    <div class="Sksq">
        <div class="control">
              <!-- <el-date-picker
                  v-model="times[0]"
                  value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  style="width:150px; margin-bottom:5px;"
                  placeholder="开始时间">
              </el-date-picker> ~ 
              <el-date-picker
                  v-model="times[1]"
                  style="width:150px;margin-bottom:5px;"
                  value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" 
                  type="datetime"
                  placeholder="结束时间">
              </el-date-picker> -->
              <el-cascader
                :options="areaOptions"
                :props='defaultProps'
                v-model="area"
                placeholder="请选择区域"
                change-on-select
                style="width: 200px;"
              ></el-cascader>
            <el-button type="primary" @click="rvsrDetail" icon="el-icon-search" ></el-button>
            <!-- <el-button type="primary" @click="excelRvsr">导出</el-button> -->
        </div>
        <h3>大型水库水情表</h3>
        <el-table
          :data="rvsrData"
          style="width: 100%"
          :height="height-10"
          class="rvsrDetailTable">
          <el-table-column type="index"  align="center"> </el-table-column>
          <el-table-column prop="STNM" label="站名" align="center" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="TM" label="时间" align="center" width="100" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="RZ" label="库水位(m)" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
                <span v-if="scope.row.RWPTN==5">{{scope.row.RZ}} <img src="@/assets/images/zup.png"/></span>
                <span v-else-if="scope.row.RWPTN==4">{{scope.row.RZ}} <img src="@/assets/images/jdown.png" /></span>
                <span v-else>{{scope.row.RZ}} <img src="@/assets/images/ping.png"/></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="INQ" label="入库流量(m3/s)"  align="center" width="120"> </el-table-column>
          <el-table-column prop="OTQ" label="出库流量(m3/s)"  align="center" width="120"> </el-table-column> -->
          <!-- <el-table-column prop="FSLTDZ" label="汛限水位(m)"  align="center" width="120"> </el-table-column> -->
          <el-table-column prop="BXX" label="比汛限(m)" align="center" width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.BXX>0" style="color: red">{{scope.row.BXX}}</span>
                    <span v-else>{{scope.row.BXX}}</span>
                </template>
          </el-table-column>
          <!-- <el-table-column label="蓄水量(百万m³)" align="center" width="120">
              <template slot-scope="scope">
                  <span v-if="scope.row.W">{{scope.row.W}}</span>
                  <span v-else>-</span>
              </template>
          </el-table-column>
          <el-table-column prop="HNNM" label="水系"  align="center" width="80"> </el-table-column>
          <el-table-column prop="RVNM" label="河流名字"  align="center" > </el-table-column>
          <el-table-column prop="HHRZ" label="历史最高水位(m)"  align="center" width="120"> </el-table-column>
          <el-table-column prop="HHRZTM" label="历史最高水位发生时间"  align="center" width="160"> </el-table-column> -->
        </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currentTotal">
      </el-pagination> -->
    </div>
</template>
<script>
import $ from "jquery";
import eChartsPlug from "@/assets/util/echartsPlug.js";
let moment = require("moment");
const alladcd = require('./hnqx.json')
export default {
  name: "Sksq",
  data() {
    return {
      height:0,
      width:0,
      rvsrData:[],
      areaOptions: alladcd,
      defaultProps: {
        children: 'children',
        label: 'adnm',
        value:'adcd'
      },
      area:['430000'],
      adcd2:'430000',
      times:this.datevalue2(),
      currentPage: 1,
      pageSize: 20,
      currentTotal: 0,
      options:window.HTCFG.AD,
    };
  },
  watch:{
    
  },  
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    datevalue2(){
        return [
              moment(new Date()).format("YYYY-MM-DD 00:00"),
              moment(new Date()).format("YYYY-MM-DD HH:mm")
        ]
    },
    //自定义滚动
    setColgroup(){
      let thatVue=this;
      setTimeout(function() {
        $(".rvsrDetailTable").find("[name='gutter'],.gutter").remove();
        let tempTable=$(".rvsrDetailTable").find("table");
        tempTable.eq(0).width("100%");
        tempTable.eq(1).width("100%");  
        let scrollbar=$(".rvsrDetailTable").find(".el-table__body-wrapper");
        let scrollbarH=scrollbar.parent().height()-60;
        scrollbar.height(scrollbarH).niceScroll({
                cursorcolor: "#3380f3", // 改变滚动条颜色，使用16进制颜色值
                cursorwidth: "5px", // 滚动条的宽度，单位：便素
                cursorborderradius: "5px", // 滚动条圆角（像素）
                cursorborder: "1px solid rgba(144,147,153,.65)", // CSS方式定义滚动条边框
                background: "rgba(144,147,153,.5)", //轨道背景
                autohidemode: "leave",
                hidecursordelay: 400, // 设置滚动条淡出的延迟时间（毫秒）
                nativeparentscrolling: true, // 检测内容底部便于让父级滚动
                smoothscroll: true, // ease动画滚动
                sensitiverail: true, // 单击轨道产生滚动
                railpadding: { top: 0, right: 1, left: 1, bottom: 0 }, // 设置轨道的内间距
                horizrailenabled:false//水平滚动
           });      
      }, 500); 
    },
    //去除政区编码尾部的0--1
    del0(str){
      str=str+"";
      if(str==""){
        return str;
      }
      let temp=str;
      for(let len=str.length,i=len-1;i>=0;i--){
        if(str.slice(i)-0!=0){
          temp=str.slice(0,i+1);
          break;
        }
      }
      if(temp == "431"){
        temp = "4310";
      }
      return temp;
    },
    async rvsrDetail(){
      this.adcd2=this.del0(this.area[this.area.length-1]);
      this.dataD=[];
      this.title='';
      this.$http.get(window.HTCFG.apiUrl +"api/core/rvsr/bigList/"+this.times[0]+"/"+this.times[1]+'/'+this.adcd2).then(res => {
          this.rvsrData=[];
          var data=res.data || res.body;
          for(var i=0;i<data.length;i++){
              data[i].STNM = data[i].STNM.trim();
              data[i].TM=moment(data[i].TM).format('MM-DD HH:mm');
              if(data[i].HHRZTM!=null){
                data[i].HHRZTM=moment(data[i].HHRZTM).format('YYYY-MM-DD HH:mm');
              }
              data[i].W=eChartsPlug.convertQ(data[i].W);
              // if(data[i].RSVRTP!="3"&&data[i].RSVRTP!="1"&&data[i].RSVRTP!="2"){
              //     this.dataD.push(data[i]);
              // }  
          }
          this.dataD = data;
          this.rvsrData=this.dataD;
          this.currentTotal=this.rvsrData.length;
          // this.setColgroup();
      })
    },
    excelRvsr(){
      this.$http.get(window.HTCFG.apiUrl +"api/core/excelRvsr/"+this.times[0]+"/"+this.times[1]+'/'+this.adcd2).then(res => {
        window.location.href = res.url;
      })
    }
  },
  mounted() {
    // $(".Sksq").height(window.innerHeight-140-35-20);
    $(".Sksq").height(window.innerHeight-100);
    var w=$(".Sksq").width();
    this.height=$(".Sksq").height();
    this.width=w;
    this.rvsrDetail()
  }
};
</script>
<style scoped lang='less'>
  .Sksq{
    width:100%;
    .control{
      margin-bottom: 10px;
    }
    h3{
      line-height: 40px;
      text-align: center;
      font-size: 26px
    }  
  }
</style>
 


// WEBPACK FOOTER //
// src/components/mobile/Sksq.vue